import { render, staticRenderFns } from "./switchClient.vue?vue&type=template&id=5cb5cb32&scoped=true"
import script from "./switchClient.vue?vue&type=script&lang=js"
export * from "./switchClient.vue?vue&type=script&lang=js"
import style0 from "./switchClient.vue?vue&type=style&index=0&id=5cb5cb32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb5cb32",
  null
  
)

export default component.exports